<template>
  <div class="filter-category-list">
    <div v-for="filter in filters" :key="filter.categoryName">
      <template v-if="!hasSubCategories(filter)">
        <FilterCategory
          :filter="filter"
          :component="filter.component"
          :is-sub-category="isSubCategory"
        />
      </template>
      <template v-else>
        <FilterCategory :filter="filter">
          <template #sub-categories>
            <FilterCategoryList
              is-sub-category
              :filters="filter.subCategories"
            />
          </template>
        </FilterCategory>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Prop, Component } from 'vue-property-decorator';

import { FilterCategory } from '../FilterCategory';
import { IFilterCategory } from '../../../../services/types/models/IFilters';

@Component({
  name: 'FilterCategoryList',
  components: { FilterCategory, FilterCategoryList }
})
export default class FilterCategoryList extends Vue {
  @Prop({ type: Array, required: true })
  public filters!: IFilterCategory[];

  @Prop({ type: Boolean, default: false })
  public isSubCategory!: boolean;

  hasSubCategories(filter: IFilterCategory) {
    return 'subCategories' in filter;
  }
}
</script>

<style lang="less" scoped>
.filter-category-list {
  display: flex;
  flex-flow: column;
  gap: 28px;
}
</style>
